import isEmail from 'validator/es/lib/isEmail';

// Same validator as the API's class-validator @IsEmail()
export const isValidEmail = (email: string): boolean => isEmail(email);
